import { render, staticRenderFns } from "./FiltersResultsBar.vue?vue&type=template&id=695bd1b0&scoped=true"
import script from "./FiltersResultsBar.vue?vue&type=script&lang=js"
export * from "./FiltersResultsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695bd1b0",
  null
  
)

export default component.exports